import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const DownloadBlock_LocalBgColor = '#CEEAF3';
const DownloadBlock_LocalBorderRadius = '12px';

export const QrLabelBlock = styled.div`
    width: 159px;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    border-radius: ${DownloadBlock_LocalBorderRadius};
    background-color: ${DownloadBlock_LocalBgColor};
    opacity: .8;
`;

export const QrBlock = styled.div`
    width: 100%;
    padding: 16px 16px 10px;
    border-radius: ${DownloadBlock_LocalBorderRadius};
    background-color: ${COLORS.Brand_Blue};
`;

export const QrCode = styled(LazyLoadImage)`
    width: 100%;
    height: 100%;
    object-position: center;
    object-fit: contain;
`;

export const LabelBlock = styled.div`
    margin: 2px auto;
    ${FONTS.H5};
    opacity: .7;
`;
